// Non-component exports for SfxPromptInput, split out of the .tsx so the component
// file only exports components (react-refresh/only-export-components).

export interface PromptCategory {
  label: string;
  prompts: string[];
}

export const SFX_PROMPT_CATEGORIES: PromptCategory[] = [
  {
    label: 'Ambient',
    prompts: [
      'ambient forest sounds with birds chirping and gentle breeze',
      'underwater ocean ambience with distant whale calls',
      'cozy fireplace crackling with rain outside the window',
      'peaceful night sounds, crickets and distant owl hoots',
      'bustling city street ambience, distant traffic and voices',
    ],
  },
  {
    label: 'SFX',
    prompts: [
      'dramatic cinematic impact hit with reverb',
      'sci-fi laser gun shooting with echo',
      'glass shattering on a hard floor',
      'explosion with debris falling',
      'metal sword unsheathing',
    ],
  },
  {
    label: 'Foley',
    prompts: [
      'footsteps on gravel path, slow walking pace',
      'old wooden door creaking open slowly',
      'paper being crumpled and thrown',
      'typing on mechanical keyboard',
      'pouring liquid into a glass',
    ],
  },
  {
    label: 'Production',
    prompts: [
      'dark ambient drone pad, low frequency',
      'uplifting cinematic riser building tension',
      'glitchy electronic texture, digital artifacts',
      'orchestral stinger, dramatic string accent',
      'whoosh transition sound effect',
    ],
  },
  {
    label: 'Nature',
    prompts: [
      'thunder rumbling in the distance',
      'gentle rain on leaves',
      'wind blowing through trees',
      'waves crashing on beach',
      'bird chirping in morning',
    ],
  },
  {
    label: 'Cinematic',
    prompts: [
      'epic cinematic boom, deep bass impact',
      'suspenseful horror violin screech',
      'heroic orchestral fanfare',
      'tense heartbeat pulsing',
      'mystical magical chime sparkle',
    ],
  },
];
